import { LinearProgress, Stack, Typography } from '@mui/material';

const ServiceCapacity = ({ capacity }) => {
    const percent = capacity && capacity.totalCapacity > 0 ? (capacity.occupancy / capacity.totalCapacity) * 100 : 0;

    const getCapacityColor = (percent) => {
        if (percent >= 90) return '#f44336'; // Red for high capacity
        if (percent >= 75) return '#ff9800'; // Orange for medium-high capacity
        return '#4caf50'; // Green for normal capacity
    };

    return (
        <Stack direction="column" spacing={1} sx={{ minWidth: 100 }}>
            <LinearProgress
                variant="determinate"
                value={percent}
                sx={{
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: '#e0e0e0',
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: getCapacityColor(percent),
                        borderRadius: 4,
                    },
                }}
            />
            <Typography variant="body2" align="center">
                {capacity.occupancy}/{capacity.totalCapacity} ({percent.toFixed(0)}%)
            </Typography>
        </Stack>
    );
};

export default ServiceCapacity;
